import { Container } from '@mui/material';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { TwoFactorSettings } from '../../presentation-components/settings-components/two-factor-settings';

// Personal-settings page hosting the two-factor authentication controls (its own
// left-menu entry). The section itself lives in TwoFactorSettings so it can be
// reused, but it is only mounted here now.
export const SettingsTwoFactorPage = () => {
  return (
    <PageOuterContainer>
      <PageHeading title="Two-factor authentication" hasTabs={false} />
      <Container maxWidth={false} sx={{ px: 0 }}>
        <TwoFactorSettings />
      </Container>
    </PageOuterContainer>
  );
};
